import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { CircularProgress } from 'atoms/loader/CircularProgress';
import { LabelL, LabelS } from 'atoms/typography';

const StyledProgress = styled(CircularProgress)`
  width: var(--double-unit);
  --circular-progress-stroke: var(--c-onBase-success);
`;

type Props = { ownedCards: number; totalCards: number };

export const CardsNumber = ({ ownedCards, totalCards }: Props) => {
  return (
    <Horizontal center>
      <StyledProgress maxProgress={totalCards} progress={ownedCards} />
      <span>
        <LabelL bold as="span">
          {ownedCards}
        </LabelL>
        <LabelS as="span" color="var(--c-nd-700)">
          /{totalCards}
        </LabelS>
      </span>
    </Horizontal>
  );
};
